var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-features"},[_c('introduce'),_c('painPoint'),_c('ability'),_c('trial')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }